import { Button, Dialog, Input, Notification, toast } from "components/ui";
import { SessionContext } from "contexts/SessionContext";
import React, { useContext, useState } from "react";
import { Trans } from "react-i18next";
import { HiMinus, HiOutlineDocumentText, HiOutlineUser, HiPlus } from "react-icons/hi";
import { HiOutlineTrash } from "react-icons/hi2";
import { IoBusinessOutline } from "react-icons/io5";
import { LuImage } from "react-icons/lu";
import { TbCode, TbPalette, TbStar } from "react-icons/tb";
import { api as Api } from "api/http";
import { formatNumber } from "utils/formatNumber";

const AddOn = (props) => {

    const {
        item, 
        recurring,
        ...rest
    } = props; 

    const { user, updateUserData } = useContext(SessionContext);
    const [ isDeleteConfirmationDialogOpen, setIsDeleteConfirmationDialogOpen ] = useState(false);
    const [ isDeleting, setIsDeleting ] = useState(false)

    const handleOnClickDeleteAddOn = () => {
        setIsDeleteConfirmationDialogOpen(true);
    }

    const deleteAddOn = () => {
        let newSubscription = user?.subscription?.items?.map((_item) => {
            return {
                "id": _item.price.id,
                "quantity": _item.quantity
            }
        });
        newSubscription = newSubscription.map((_item) => {
            if (_item.id == item.price.id) {
                _item.quantity = _item.quantity - 1;
            }
            return _item;
        })
        newSubscription = newSubscription.filter(item => item.quantity > 0);

        setIsDeleting(true);
        Api.put(`/subscriptions`, {}, { prices: newSubscription }).then((response) => {
            toast.push(<Notification title="Your plan has been updated" type="success" />, { placement: "top-center" });
            updateUserData();
            setIsDeleting(false);
            setIsDeleteConfirmationDialogOpen(false);
        }).catch((err) => {
            toast.push(<Notification title={err?.message || "An error ocurred. Please, try again later."} type="danger" />, { placement: "top-center" });
        }).finally(() => {
            setIsDeleting(false);
        });
    }

    const icon = 
        (item.product.name || "")?.toLowerCase()?.includes("words")
            ? <HiOutlineDocumentText className="text-xl" />
            : (item.product.name || "")?.toLowerCase()?.includes("user")
                ? <HiOutlineUser className="text-xl" />
                : (item.product.name || "")?.toLowerCase()?.includes("company")
                    ? <IoBusinessOutline className="text-xl" />
                    : (item.product.name || "")?.toLowerCase()?.includes("white")
                        ? <TbPalette className="text-xl" />
                        : (item.product.name || "")?.toLowerCase()?.includes("plus")
                            ? <TbStar className="text-xl" />
                            : (item.product.name || "")?.toLowerCase()?.includes("api")
                                ? <TbCode className="text-xl" />
                                : (item.product.name || "")?.toLowerCase()?.includes("image")
                                    ? <LuImage className="text-xl" />
                                    : null;

    return (
        <div className="group relative overflow-hidden rounded-2xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900 p-5 shadow-sm hover:shadow-md transition-all" {...rest}>
            <div className="absolute top-4 right-4">
                <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs bg-tertiary-100 dark:bg-gray-800 text-tertiary-700 dark:text-gray-200 border border-tertiary-200/60 dark:border-gray-700">
                    x{item.quantity}
                </span>
            </div>
            <div className="flex items-center gap-4">
                <div className="w-11 h-11 rounded-xl bg-primary-50 dark:bg-primary-800 flex items-center justify-center text-primary-500 dark:text-primary-400">
                    {icon}
                </div>
                <div className="flex-1 min-w-0">
                    <h6 className="!text-sm font-semibold truncate leading-tight">{item.product.description}</h6>
                    <div className="mt-0.5 !text-xs text-gray-500 dark:text-gray-400 truncate">
                        {recurring == "year" ? <Trans i18nKey={`subscription.billed`}>Billed</Trans> : <Trans i18nKey={`subscription.billed`}>Billed</Trans>} {recurring}
                    </div>
                </div>
            </div>
            <div className="mt-4 flex items-center justify-between">
                <div className="flex flex-col">
                    <span className="!text-xl !font-bold leading-none">${formatNumber(item.price.amount / (recurring == "year" ? 12 : 1) / 100, 2)}</span>
                    <span className="text-xs text-gray-500 dark:text-gray-400"><Trans i18nKey={`subscription.perMonth`}>per month</Trans></span>
                </div>
                <div className="flex items-center gap-2">
                    <Button size="sm" variant="twoTone" color="red-700" onClick={handleOnClickDeleteAddOn} icon={<HiOutlineTrash />}></Button>
                </div>
            </div>

            <Dialog
                isOpen={isDeleteConfirmationDialogOpen}
                onClose={() => setIsDeleteConfirmationDialogOpen(false)}
                onRequestClose={() => setIsDeleteConfirmationDialogOpen(false)}
                overlayClassName="flex items-center justify-center w-full"
                closeButtonClassName="!hidden"
            >
                <div className='flex flex-col gap-4 pt-4'>
                    <p className='text-center w-full text-base text-tertiary-800 dark:text-gray-200'><Trans i18nKey={`subscription.areYouSureRemoveAddOn`}>Are you sure you want to remove the add-on?</Trans></p>
                    <div className='flex justify-center w-full items-center gap-2 pt-4'>
                        <Button variant="plain" onClick={() => setIsDeleteConfirmationDialogOpen(false)}><Trans i18nKey={`subscription.cancel`}>Cancel</Trans></Button>
                        <Button variant="twoTone" color="red-600" loading={isDeleting} onClick={deleteAddOn}><Trans i18nKey={`subscription.confirm`}>Confirm</Trans></Button>
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default AddOn;